module.exports = __webpack_public_path__ + "static/img/抽奖细则.7409361.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/daily/抽奖细则.png
// module id = 559
// module chunks = 1